<template>
  <div
    class="octadesk--card"
    :style="{
      top: `${headerHeight}px`,
      bottom: '50px'
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['headerHeight'])
    }
  }
</script>

<style scoped>
  .octadesk--card {
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  }

  .octadesk--card:not(.octadesk-kb--card) {
    top: auto !important;
    bottom: auto !important;
    margin-bottom: 60px;
  }
</style>
